import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import cx from "classnames";

import {
  getSecondaryUser,
  getUser,
  purgeSecondarySessionKey,
  purgeSecondaryUser,
  purgeSessionKey,
  purgeUser,
} from "../../../../../utils/SsoSession";
import {
  Roles,
  UserDto,
} from "../../../../../modules/Account/AccountLogin/types";
import LanguageSelection from "./languageSelection";

const UserMenu: FC = (props: any) => {
  const { t } = useTranslation();
  const [isAdmin, setIsAdmin] = useState<boolean>(false);
  const [filledBoxes, setFilledBoxes] = useState(0);

  const goLoginAsUserPage = () => {
    window.location.href = window.location.origin + "/login-as-user";
  };
  const goMyProfilePage = () => {
    window.location.href = window.location.origin + "/my-profile";
  };
  const goClientPage = () => {
    window.location.href = window.location.origin + "/client-page";
  };

  const goExternalUserPage = () => {
    window.location.href = window.location.origin + "/external-user-page";
  };

  const goPortalSelectionPage = () => {
    window.location.href = window.location.origin + "/portal-selection";
  };
  const onLogout = () => {
    purgeSessionKey();
    purgeUser();
    purgeSecondarySessionKey();
    purgeSecondaryUser();
    window.location.href = window.location.origin + "/login";
  };
  useEffect(() => {
    const user = getSecondaryUser() ? getSecondaryUser() : getUser();
    if (user) {
      let userJson: UserDto = JSON.parse(user);
      const isAdmin = userJson.userRoles.some(
        (x) => x.toString() === Roles.admin.toString()
      );
      setIsAdmin(isAdmin);
    }
  }, []);

  useEffect(() => {
    let timer: string | number | NodeJS.Timeout | undefined;
    if (filledBoxes < 3) {
      timer = setTimeout(() => {
        setFilledBoxes((prev) => prev + 1);
      }, 1000);
    } else if (filledBoxes === 3) {
      timer = setTimeout(() => {
        setFilledBoxes(0);
      }, 1000);
    }

    return () => clearTimeout(timer);
  }, [filledBoxes]);
  const styles = {
    container: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height: "100vh",
      textAlign: "center",
    },
    text: {
      marginBottom: "20px",
      fontSize: "20px",
      fontWeight: "bold",
    },
    boxContainer: {
      display: "flex",
      gap: "10px",
      justifyContent: "center",
    },
    box: {
      width: "10px",
      height: "10px",
      borderRadius: "50%",
      transition: "background-color 0.5s ease",
      border: "1px solid #000",
      backgroundColor: "transparent",
    },
  };

  return (
    <div
      className="container mt-3"
      style={{ height: "100%", overflow: "hidden" }}
    >
      <nav className="navbar navbar-expand-lg navbar-light bg-light rounded-pill">
        <div className="container-fluid">
          <a className="navbar-brand d-flex align-items-center" href="#">
            <img
              src="apple-touch-icon-removebg-preview.png"
              alt="Securitas Logo"
              width="50"
              height="50"
              className="d-inline-block align-text-top me-2"
            />
          </a>

          <button
            className="navbar-toggler "
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#responsiveNavbar"
            aria-controls="responsiveNavbar"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="30"
                fill="none"
                viewBox="0 0 30 30"
              >
                <path
                  stroke="rgba(0,0,0,0.5)"
                  strokeLinecap="round"
                  strokeMiterlimit="10"
                  strokeWidth="2"
                  d="M4 7h22M4 15h22M4 23h22"
                />
              </svg>
            </span>{" "}
          </button>

          <div className="collapse navbar-collapse" id="responsiveNavbar">
            <ul
              className="navbar-nav ms-auto mb-2 mb-lg-0"
              style={{ alignItems: "center" }}
            >
              {isAdmin && (
                <>
                  <li className="nav-item me-2">
                    <a
                      className="nav-link d-lg-none"
                      style={{ cursor: "pointer" }}
                      onClick={goLoginAsUserPage}
                    >
                      {t("Login As User")}
                    </a>
                    {/* Masaüstünde buton */}
                    <button
                      className={cx(
                        "btn d-none d-lg-inline border-0 rounded-pill",
                        {
                          "btn-outline-dark":
                            window.location.pathname !== "/login-as-user",
                          "btn-dark":
                            window.location.pathname === "/login-as-user",
                        }
                      )}
                      onClick={goLoginAsUserPage}
                    >
                      {t("Login As User")}
                    </button>
                  </li>
                  <li className="nav-item me-2">
                    <a
                      className="nav-link d-lg-none "
                      style={{ cursor: "pointer" }}
                      onClick={goClientPage}
                    >
                      {t("Portal Management")}
                    </a>
                    <button
                      className={cx(
                        "btn d-none d-lg-inline border-0 rounded-pill",
                        {
                          "btn-outline-dark":
                            window.location.pathname !== "/client-page",
                          "btn-dark":
                            window.location.pathname === "/client-page",
                        }
                      )}
                      onClick={goClientPage}
                    >
                      {t("Portal Management")}
                    </button>
                  </li>
                  <li className="nav-item me-2">
                    <a
                      className="nav-link d-lg-none "
                      style={{ cursor: "pointer" }}
                      onClick={goExternalUserPage}
                    >
                      {t("External Users")}
                    </a>
                    <button
                      className={cx(
                        "btn d-none d-lg-inline border-0 rounded-pill",
                        {
                          "btn-outline-dark":
                            window.location.pathname !== "/external-user-page",
                          "btn-dark":
                            window.location.pathname === "/external-user-page",
                        }
                      )}
                      onClick={goExternalUserPage}
                    >
                      {t("External Users")}
                    </button>
                  </li>
                </>
              )}

              <li className="nav-item me-2">
                <a
                  className="nav-link d-lg-none"
                  style={{ cursor: "pointer" }}
                  onClick={goMyProfilePage}
                >
                  {t("Profile")}
                </a>
                <button
                  className={cx(
                    "btn d-none d-lg-inline border-0 rounded-pill",
                    {
                      "btn-outline-dark":
                        window.location.pathname !== "/my-profile",
                      "btn-dark": window.location.pathname === "/my-profile",
                    }
                  )}
                  onClick={goMyProfilePage}
                >
                  {t("Profile")}
                </button>
              </li>

              <li className="nav-item me-2">
                <a
                  className="nav-link d-lg-none"
                  style={{ cursor: "pointer" }}
                  onClick={goPortalSelectionPage}
                >
                  {t("Portal Selection")}
                </a>
                <button
                  className={cx(
                    "btn d-none d-lg-inline border-0 rounded-pill",
                    {
                      "btn-outline-dark":
                        window.location.pathname !== "/portal-selection",
                      "btn-dark":
                        window.location.pathname === "/portal-selection",
                    }
                  )}
                  onClick={goPortalSelectionPage}
                >
                  {t("Portal Selection")}
                </button>
              </li>

              <li className="nav-item">
                <a
                  className="nav-link d-lg-none text-danger"
                  style={{ cursor: "pointer" }}
                  onClick={onLogout}
                >
                  {t("Safe Exit")}
                </a>
                <button
                  className="btn btn-outline-danger d-none d-lg-inline border-0 rounded-pill"
                  onClick={onLogout}
                >
                  {t("Safe Exit")}
                </button>
              </li>

              <li className="nav-item">
                <a
                  className="nav-link d-lg-none text-danger"
                  style={{ cursor: "pointer" }}
                >
                  <LanguageSelection />
                </a>
                <button className="btn d-none d-lg-inline border-0 rounded-pill">
                  <LanguageSelection />
                </button>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      <div className="row">
        <div className="col-md-12">
          <div className="mb-1 mt-1" style={{ textAlign: "center" }}>
            <img
              src="https://www.securitas.com.tr/build/images/brand/securitas_ab_logo_alt.svg"
              width="100px"
              alt=""
            />
          </div>
          <div className="mb-2" style={{ textAlign: "center" }}>
            <strong
              className="mt-5"
              style={{
                fontSize: 20,
                textAlign: "center",
              }}
            >
              <div>
                <p>Securitas Güvenlik Hizmetleri A.Ş.</p>
                <div style={styles.boxContainer}>
                  {[0, 1, 2].map((index) => (
                    <div
                      key={index}
                      style={{
                        ...styles.box,
                        backgroundColor:
                          index < filledBoxes ? "red" : "transparent",
                        border: index < filledBoxes ? "none" : "1px solid #000",
                        transition: "background-color 1s ease-in-out",
                      }}
                    ></div>
                  ))}
                </div>
              </div>
            </strong>
          </div>
        </div>
      </div>
      {/* <div className="row mb-5 text-center">
        <h4>
          <span>{t("Please select the portal you want to login.")}</span>
        </h4>
      </div> */}
    </div>
  );
};

export default UserMenu;
